import React, { useEffect } from "react";
import { Route, Routes, BrowserRouter, useLocation } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import Home from "./screens/Home/Home";
import Blog from "./screens/Blog/Blog";
import BlogDetails from "./screens/Blog/BlogDetails/BlogDetails";
import ContactUs from "./screens/Contact/ContactUs";
import Privacy from "./screens/Legal/Privacy";
import Terms from "./screens/Legal/Terms";
import OAuthRedirect from "./mobile-app/OAuthRedirect";
import NotFound from "./screens/NotFound/NotFound";
import Safety from "./screens/Safety/Safety";
import Features from "./screens/Features/Features";
import Ambassadors from "./screens/Ambassadors/Ambassadors";
import AmbassadorsRecruit from "./screens/Ambassadors/Recruit";
import AmbassadorsRewards from "./screens/Ambassadors/Rewards";
import AmbassadorsApplicationForm from "./screens/Ambassadors/ApplicationForm";
import VendorProfileRedirect from "./mobile-app/VendorProfileRedirect";
import MealPreviewRedirect from "./mobile-app/MealPreviewRedirect";
import DownloadOptions from "./mobile-app/download/DownloadOptions";
import RiderDownloadOptions from "./mobile-app/download/RiderDownloadOptions";
import UserDownloadRedirect from "./mobile-app/download/UserDownloadRedirect";
import RiderDownloadRedirect from "./mobile-app/download/RiderDownloadRedirect";
import { loadIntercom, bootIntercom, updateIntercom } from "./utils/intercom";
import { INTERCOM_APP_ID } from "./common/config/config";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    updateIntercom();
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    if (INTERCOM_APP_ID) {
      loadIntercom(INTERCOM_APP_ID);
      bootIntercom(INTERCOM_APP_ID);
    } else {
      console.warn("Failed to load Intercom App ID");
    }
  }, []);

  return (
    <ThemeProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="flex flex-col min-h-screen">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogDetails />} />
            <Route path="/help-center" element={<ContactUs />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/features" element={<Features />} />
            <Route path="/safety-guidelines" element={<Safety />} />
            <Route path="/ambassadors" element={<Ambassadors />} />
            <Route
              path="/ambassadors/apply"
              element={<AmbassadorsRecruit />}
            />
            <Route
              path="/ambassadors/rewards"
              element={<AmbassadorsRewards />}
            />
            <Route
              path="/ambassadors/form"
              element={<AmbassadorsApplicationForm />}
            />
            <Route
              path="/mobile-app/oauth-redirect/v2/:env"
              element={<OAuthRedirect />}
            />
            <Route
              path="/mobile-app/oauth-redirect/:env"
              element={<OAuthRedirect />}
            />
            {/* Universal / App Link paths — the app itself claims /share/*.
                These pages only render for visitors without the app installed. */}
            <Route
              path="/share/:username"
              element={<VendorProfileRedirect />}
            />
            <Route
              path="/share/:username/menu/:menuItemId"
              element={<MealPreviewRedirect />}
            />
            {/* Legacy share links and printed QR codes — bounce via the squaay:// scheme. */}
            <Route path="/:username" element={<VendorProfileRedirect />} />
            <Route
              path="/:username/menu/:menuItemId"
              element={<MealPreviewRedirect />}
            />
            <Route path="/download" element={<UserDownloadRedirect />} />
            <Route path="/download-options" element={<DownloadOptions />} />
            <Route
              path="/download-riders"
              element={<RiderDownloadRedirect />}
            />
            <Route
              path="/download-riders-options"
              element={<RiderDownloadOptions />}
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
